export const SHIPPING_COST = 250;
export const FREE_SHIPPING_THRESHOLD = 3000;

export const getShippingCost = (subtotal) =>
  subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : SHIPPING_COST;

export const getAmountUntilFreeShipping = (subtotal) =>
  Math.max(FREE_SHIPPING_THRESHOLD - subtotal, 0);
